import { render, staticRenderFns } from "./PersonnelTicketDetails.vue?vue&type=template&id=7a45aa40&scoped=true"
import script from "./PersonnelTicketDetails.vue?vue&type=script&lang=js"
export * from "./PersonnelTicketDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a45aa40",
  null
  
)

export default component.exports